export default "__VITE_ASSET__bqYNgJ$z__"